<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ตั้งค่าประเภทบัตร (Platform)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        Whitelist ประเภทบัตร free / expiry ที่ Platform คุมโควต้า
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <button (click)="onRefresh()"
        class="p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" (click)="openCreate()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg shadow-amber-200/50 dark:shadow-none flex items-center justify-center gap-2 h-[46px] transition-all">
        <span class="material-icons">add_circle</span>
        สร้าง Config
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden relative"
    style="animation-delay: 0.1s;">
    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">credit_card</span>
        รายการ Whitelist
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </h3>
      <div class="w-full sm:w-56">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สถานะ</label>
        <select [ngModel]="filterEnable()" (ngModelChange)="filterEnable.set($event); onFilterChange()"
          class="w-full bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 h-[46px]">
          <option value="all">ทั้งหมด</option>
          <option value="true">เปิดใช้งาน</option>
          <option value="false">ปิดใช้งาน</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto h-[520px] relative custom-scrollbar" [class.opacity-50]="isLoading()">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
          <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
            <th class="p-5">ชื่อ</th>
            <th class="p-5">ประเภทบัตร</th>
            <th class="p-5">Subscription</th>
            <th class="p-5">Scope</th>
            <th class="p-5">ลาน</th>
            <th class="p-5 text-center">Platform</th>
            <th class="p-5 text-center">สถานะ</th>
            <th class="p-5 text-center w-[110px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200">
            <td class="p-5 font-semibold text-slate-700 dark:text-slate-200">{{ item.name || '-' }}</td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300">{{ item.cardTypeName }}</td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300">{{ item.subscriptionName || '-' }}</td>
            <td class="p-5">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800">
                {{ scopeLabel(item.cardScope) }}
              </span>
            </td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300">{{ item.siteName || ('Site ' + item.siteId) }}</td>
            <td class="p-5 text-center">
              <span class="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-bold border"
                [ngClass]="item.managedByPlatform
                  ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700'">
                {{ item.managedByPlatform ? 'ใช่' : 'ไม่' }}
              </span>
            </td>
            <td class="p-5 text-center">
              <span class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm"
                [ngClass]="item.enable
                  ? 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-600 dark:text-slate-400 border-slate-200 dark:border-slate-700'">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5" [ngClass]="item.enable ? 'bg-green-500' : 'bg-slate-400'"></span>
                {{ item.enable ? 'เปิด' : 'ปิด' }}
              </span>
            </td>
            <td class="p-5 text-center">
              <div class="flex items-center justify-center gap-1.5">
                <button *ngIf="canUpdate" (click)="openEdit(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all"
                  title="แก้ไข">
                  <span class="material-icons text-base">edit</span>
                </button>
                <button *ngIf="canDelete" (click)="openDeleteConfirm(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-rose-400 text-slate-400 hover:text-rose-500 transition-all"
                  title="ลบ">
                  <span class="material-icons text-base">delete</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="items().length === 0 && !isLoading()">
            <td colspan="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2">search_off</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">
                  {{ selectedSiteId ? 'ไม่พบ whitelist ของลานนี้' : 'กรุณาเลือกลานจาก Sidebar' }}
                </p>
                <span *ngIf="selectedSiteId" class="text-sm mt-1">สร้าง config ก่อนออกบัตรโควต้า</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="text-sm text-slate-500 dark:text-slate-400 font-medium">
        แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="p === currentPage() ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ p }}
        </button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-card-type-config *ngIf="isModalOpen()" [configId]="selectedConfigId()"
  [siteId]="selectedSiteId" [siteName]="selectedSiteName"
  (close)="closeModal()" (saveSuccess)="loadTable()"></app-modal-card-type-config>

<app-pss-confirm-modal *ngIf="isDeleteConfirmOpen()" title="ยืนยันการลบ?" message="ลบ config"
  [highlight]="deleteTarget()?.name || ''" messageSuffix="หรือไม่?" confirmLabel="ลบข้อมูล" cancelLabel="ยกเลิก"
  variant="danger" icon="delete_forever" (confirm)="confirmDelete()" (cancel)="closeDeleteConfirm()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
